import { atom } from 'recoil';
import { FilterDef } from '../../../../constants/FinanceModels';

export const STATE_TABLE_UPDATING = atom<boolean>({
    key: "payments-outstanding-state-table-updating",
    default: false
});

export const STATE_ACTIVE_FILTERS = atom<FilterDef[]>({
    key: 'payments-outstanding-state-active-filters',
    default: []
});

export const STATE_MODAL_UPDATING = atom<boolean>({
    key: "payments-outstanding-state-modal-updating",
    default: false
});

